import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import RegistrationForm from './Register/RegistrationForm';
const RegisterPanel = ({ className, onRegister }) => {
    return (_jsx("div", { className: classnames(className), children: _jsx(RegistrationForm, { onRegister: onRegister }) }));
};
export default RegisterPanel;
